import React from 'react';

const Login = () => {
    return (
        <div className='m-5 p-5'>
            <h3>This is Login</h3>
        </div>
    );
};

export default Login;